import {
  Box,
  Card,
  InputAdornment,
  TableBody,
  TextField,
  Typography,
} from "@mui/material";
import useTable from "../../../hooks/useTable";
import SearchIcon from "../../../icons/Search";
import SingleTemplateInfo from "./SingleTemplateInfo";

const headCells = [
  { id: "slNo", label: "#" },
  { id: "label", label: "LABEL" },
  { id: "description", label: "DESCRIPTION" },
  { id: "action", label: "ACTION" },
];

const ViewAllProjectTemplates = (props) => {
  const { data, getAllTemplates, searchHandler, nameSearchValue } = props;

  const { TblContainer, TblHead, recordsAfterPagingAndSorting } = useTable(
    data,
    headCells
  );
  return (
    <Card>
      <Box
        sx={{
          m: -1,
          p: 3,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <Typography
            variant="dashboardContentHeader"
            sx={{
              color: "#2D3E56",
              mb: "18px",
              display: "inline",
            }}
          >
            All Templates
          </Typography>
        </Box>
        <Box
          sx={{
            m: 1,
            maxWidth: "100%",
            width: 240,
          }}
        >
          <TextField
            label="Search Template"
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
            onChange={searchHandler}
            placeholder="Enter template title"
            value={nameSearchValue}
            variant="outlined"
          />
        </Box>
      </Box>
      <Box sx={{ pt: 3 }}>
        <TblContainer>
          <TblHead />
          {data?.length > 0 && (
            <TableBody>
              {recordsAfterPagingAndSorting().map((template, index) => {
                return (
                  <SingleTemplateInfo
                    template={template}
                    key={index}
                    index={index}
                    getAllTemplates={getAllTemplates}
                  />
                );
              })}
            </TableBody>
          )}
        </TblContainer>
      </Box>
    </Card>
  );
};

export default ViewAllProjectTemplates;
